import { render } from "./custom-data.vue?vue&type=template&id=57e6e838&scoped=true"
import script from "./custom-data.vue?vue&type=script&lang=js"
export * from "./custom-data.vue?vue&type=script&lang=js"

import "./custom-data.vue?vue&type=style&index=0&id=57e6e838&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e6e838"]])

export default __exports__